app.controller("PermissionController", ["$scope", "$uibModal", "Access", "$stateParams",
    function ($scope, $uibModal, Access, $stateParams) {
        $scope.permissions = [];

        function loadPermissions() {
            Access.fetchPermissionList($stateParams.type).then(function (data) {
                $scope.permissions = data;
            });
        }

        loadPermissions();

        $scope.add = function () {
            $uibModal.open({
                controller: "AddPermissionController",
                templateUrl: _pb + 'sudo/access/add-permission.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    permission: function () {
                        return {
                            type: $stateParams.type
                        };
                    }
                }
            }).result
                .then(function (result) {
                    loadPermissions();
                }, function () {
                });
        };

        $scope.edit = function (permission) {
            $uibModal.open({
                controller: "EditPermissionController",
                templateUrl: _pb + 'sudo/access/edit-permission.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    permission: function () {
                        return {
                            _id: permission._id,
                            name: permission.name,
                            description: permission.description
                        };
                    }
                }
            }).result
                .then(function (result) {
                    loadPermissions();
                }, function () {
                });
        };

    }
]);
